/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const scheduleMutationResponseOutputScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const scheduleMutationResponseOutputVersionExclusiveMin = 0;
export const scheduleMutationResponseOutputVersionMax = 9007199254740991;

export const scheduleMutationResponseOutputRoutineIdsItemRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const scheduleMutationResponseOutputRoutineIdsMax = 10;

export const scheduleMutationResponseOutputEffectiveAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);

export const ScheduleMutationResponseOutput = zod.object({
  scheduleId: zod.uuid().regex(scheduleMutationResponseOutputScheduleIdRegExp),
  version: zod
    .int()
    .gt(scheduleMutationResponseOutputVersionExclusiveMin)
    .max(scheduleMutationResponseOutputVersionMax),
  routineIds: zod
    .array(zod.uuid().regex(scheduleMutationResponseOutputRoutineIdsItemRegExp))
    .max(scheduleMutationResponseOutputRoutineIdsMax),
  effectiveAt: zod.iso
    .datetime({ offset: true })
    .regex(scheduleMutationResponseOutputEffectiveAtRegExp),
});

export type ScheduleMutationResponseOutput = zod.input<typeof ScheduleMutationResponseOutput>;
export type ScheduleMutationResponseOutputOutput = zod.output<
  typeof ScheduleMutationResponseOutput
>;
